import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { getDisplayName } from '@grandvisionhq/utils';
import '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import '../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../utils/http-client.js';
import { useBloomreachData } from '../hooks/use-bloomreach-data.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../operations/mutations/signup-promotion.js';
import '../operations/mutations/subscribe-newsletter.js';
import '../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../hooks/use-breakpoint-visibility.js';

function withBloomreachData(Component) {
    const displayName = getDisplayName(Component);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const WithBloomreachData = (props)=>{
        const { ref , data  } = useBloomreachData(props);
        if (!data || !data.content) {
            console.error(`Tried to render CmsComponent ${displayName} without content object with ref: ${ref}`);
            return /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, props));
        }
        return /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, data, props));
    };
    WithBloomreachData.displayName = `WithBloomreachData(${displayName})`;
    return WithBloomreachData;
}

export { withBloomreachData };
//# sourceMappingURL=with-bloomreach-data.js.map
